import { render, staticRenderFns } from "./news-detail.html?vue&type=template&id=b053189c&scoped=true&external"
import script from "./news-detail.js?vue&type=script&lang=js&external"
export * from "./news-detail.js?vue&type=script&lang=js&external"
import style0 from "./news-detail.scss?vue&type=style&index=0&id=b053189c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b053189c",
  null
  
)

export default component.exports